import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import SendUsMessage from "../../components/SendUsMessage/SendUsMessage";
import Footer from "../../components/Footer";

const FAQSPage = () => {

	return (
		<div>
			<Helmet>
				<title>Send Us Message</title>
			</Helmet>
			<Header />
			<SendUsMessage />
			<Footer />
		</div>
	);
};

export default FAQSPage;